import { AccountMenu } from "@modules:AccountMenu";
import { Box } from "@mui/material";
import { ReactNode } from "react";

interface HeaderProps {
  leftSide?: ReactNode;
  rightSide?: ReactNode;
}

export const Header = ({ leftSide, rightSide }: HeaderProps) => {
  return (
    <Box
      className="Settings__Header"
      sx={{
        display: "flex",
        alignItems: "center",
        height: "64px",
        paddingX: "16px",
        borderBottom: "1px solid #E0E0E0",
        backgroundColor: "#FFFFFF",
        position: "sticky",
        top: 0,
        zIndex: 100,
        justifyContent: leftSide ? "space-between" : "flex-end",
      }}
    >
      {leftSide}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {rightSide}
        <AccountMenu />
      </Box>
    </Box>
  );
};
